var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalTonnage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.711,
    height: 22.663,
    viewBox: "0 0 22.711 22.663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Total_tonnage_",
    "data-name": "Total tonnage ",
    transform: "translate(-144.142 -144.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M221.2,297.92H203.31a.967.967,0,0,1-.964-.964V284.226a.964.964,0,1,1,1.929,0v11.765h16.973a.967.967,0,0,1,.964.964,1.01,1.01,0,0,1-1.013.964Z",
    transform: "translate(-55.359 -132.319)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M148.048,151.956a3.906,3.906,0,1,1,3.906-3.906A3.89,3.89,0,0,1,148.048,151.956Zm0-5.931a2.025,2.025,0,1,0,2.025,2.025A2.037,2.037,0,0,0,148.048,146.024Z",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M253.64,546.862a.967.967,0,0,1-.964-.964v-1.205a.964.964,0,1,1,1.929,0V545.9A1,1,0,0,1,253.64,546.862Z",
    transform: "translate(-103.23 -380.055)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M520.02,546.862a.967.967,0,0,1-.964-.964v-1.205a.964.964,0,0,1,1.929,0V545.9A1,1,0,0,1,520.02,546.862Z",
    transform: "translate(-356.591 -380.055)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M321.083,276.615H310.86a.967.967,0,0,1-.964-.964V265.476a.967.967,0,0,1,.964-.964h10.222a.967.967,0,0,1,.964.964V275.7a.958.958,0,0,1-.965.916Zm-9.258-1.881h8.342v-8.294h-8.342Z",
    transform: "translate(-157.653 -114.485)",
    fill: "#ff7200"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTonnage);
export default __webpack_public_path__ + "static/media/TotalTonnage.e5014513534e69d50014dbc8ca787302.svg";
export { ForwardRef as ReactComponent };